export default __webpack_public_path__ + "static/text-styles-do-84bbe0f42ee176ddd1e9b9d630dd7f187e99ad721221986226dd72953dfad10b.png";